/* eslint-disable */
import { TimelineMax, TweenMax } from 'gsap';
import QRCode from './qrcode.min.js';

export {
    TimelineMax,
    TweenMax,
    QRCode
};
